import { createAddressUseCase } from '@src/main/modules/messages/application/use-cases/create/create-address.usecase';
import { CreateAddressRequest } from '@src/main/modules/messages/infrastructure/dto/createAddressRequest';
import { createAddressHttpRepository } from '@src/main/modules/messages/infrastructure/repository/AddressHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useCreateAddress = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createAddressHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (data: CreateAddressRequest) => {
      if (!repository) throw new Error('Repository not initialized');
      return await createAddressUseCase(data, tokenProvider);
    },
  });
};
